import React from "react";
import PropTypes from "prop-types";
import { visuallyHidden } from "@mui/utils";

/**
 * Блоки страницы своего H1 не рисуют, поэтому название страницы кладём
 * в скрытый H1 для поисковиков и скринридеров.
 */
export default function PageHeading({ title }) {
  return <h1 style={visuallyHidden}>{title}</h1>;
}

PageHeading.propTypes = {
  title: PropTypes.string.isRequired,
};
